import { render, staticRenderFns } from "./companyDetails.vue?vue&type=template&id=5da1fb5c"
import script from "./companyDetails.vue?vue&type=script&lang=js"
export * from "./companyDetails.vue?vue&type=script&lang=js"
import style0 from "./companyDetails.vue?vue&type=style&index=0&id=5da1fb5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports